import { avatarColor, initials } from './format';

/** Rounded-square avatar with a deterministic green background + initials. */
export function LwAvatar({ first, last, className }: { first: string; last: string; className?: string }) {
  return (
    <span className={className ? `avatar ${className}` : 'avatar'} style={{ background: avatarColor(first + last) }}>
      {initials(first, last)}
    </span>
  );
}
